<!-- Add/Edit Modal -->
<div class="modal fade" bsModal #addEditModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isNew ? 'Add Widget Template' : 'Edit Widget Template' }}</h5>
        <button type="button" class="btn-close" (click)="addEditModal.hide()"></button>
      </div>
      <div class="modal-body" *ngIf="editingTemplate">
        <div class="row g-3">
          <!-- Left: metadata fields -->
          <div class="col-lg-5">
            <div class="row g-2">
              <div class="col-12">
                <label class="form-label">Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="editingTemplate.name" placeholder="Template name" />
              </div>
              <div class="col-12">
                <label class="form-label">Description</label>
                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="editingTemplate.description" placeholder="Short description shown in the gallery"></textarea>
              </div>
              <div class="col-6">
                <label class="form-label">Type <span class="text-danger">*</span></label>
                <select class="form-select form-select-sm" [(ngModel)]="editingTemplate.type">
                  <option [ngValue]="0">Free Text</option>
                  <option [ngValue]="1">Multi Text</option>
                </select>
              </div>
              <div class="col-6">
                <label class="form-label">Category</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="editingTemplate.category" placeholder="e.g. sensor, alarm" />
              </div>
              <div class="col-6">
                <label class="form-label">Site Type</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="editingTemplate.siteType" placeholder="Leave blank for all" />
              </div>
              <div class="col-6">
                <label class="form-label">Customer ID</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="editingTemplate.customerId" placeholder="Leave blank for global" />
              </div>
              <div class="col-6">
                <label class="form-label">Sort Order</label>
                <input type="number" class="form-control form-control-sm" [(ngModel)]="editingTemplate.sortOrder" />
              </div>
              <div class="col-3">
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" id="chkIsActive" [(ngModel)]="editingTemplate.isActive">
                  <label class="form-check-label" for="chkIsActive">Active</label>
                </div>
              </div>
              <div class="col-3">
                <div class="form-check mt-2">
                  <input class="form-check-input" type="checkbox" id="chkIsSystem" [(ngModel)]="editingTemplate.isSystem">
                  <label class="form-check-label" for="chkIsSystem">System</label>
                </div>
              </div>
              <!-- Preview image -->
              <div class="col-12 mt-1">
                <label class="form-label">Preview Image</label>
                <input type="file" class="form-control form-control-sm" accept="image/*,.svg" (change)="onPreviewImageSelected($event)" />
                <div class="mt-2" *ngIf="!isNew && editingTemplate.hasPreviewImage && !previewImageFile">
                  <img [src]="getPreviewImageUrl(editingTemplate.id)" style="max-height:80px; border-radius:4px;" alt="Current preview" />
                  <div class="text-muted small mt-1">Select a new file above to replace.</div>
                </div>
                <div class="mt-1" *ngIf="previewImageFile">
                  <span class="badge bg-secondary">{{previewImageFile.name}}</span>
                </div>
              </div>
            </div>

            <!-- Live preview -->
            <div class="mt-3">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <label class="form-label mb-0">Live Preview</label>
                <button class="btn btn-sm btn-outline-secondary" (click)="refreshPreview()">
                  <i class="bi bi-arrow-clockwise"></i> Refresh
                </button>
              </div>
              <div class="preview-pane border rounded p-2" [innerHTML]="livePreviewHtml | safe:'html'"></div>
            </div>
          </div>

          <!-- Right: HTML editor -->
          <div class="col-lg-7">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <label class="form-label mb-0">HTML Template</label>
              <button class="btn btn-sm btn-outline-secondary" (click)="formatHtml()" title="Format HTML (Ctrl+Shift+F)">
                <i class="bi bi-code-slash"></i> Format <small class="text-muted ms-1">Ctrl+Shift+F</small>
              </button>
            </div>
            <ngx-monaco-editor
              [(ngModel)]="editingTemplate.html"
              [options]="{ language: 'html', theme: 'vs', readOnly: false, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
              (onInit)="onHtmlEditorInit($event)"
              (ngModelChange)="refreshPreview()"
              style="display:block; height: 400px; width: 100%; overflow: auto;">
            </ngx-monaco-editor>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" (click)="addEditModal.hide()">Cancel</button>
        <button class="btn btn-primary" (click)="save()" [disabled]="saving || !editingTemplate?.name">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          {{ isNew ? 'Create' : 'Save Changes' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Main content -->
<div class="row">
  <div class="col-12">
    <div class="card mt-2">
      <div class="card-header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-3">
          <h5 class="mb-0">Widget Text Templates</h5>
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn" [ngClass]="typeFilter === null ? 'btn-secondary' : 'btn-outline-secondary'" (click)="typeFilter = null">All</button>
            <button type="button" class="btn" [ngClass]="typeFilter === 0 ? 'btn-primary' : 'btn-outline-secondary'" (click)="typeFilter = 0">Free Text</button>
            <button type="button" class="btn" [ngClass]="typeFilter === 1 ? 'btn-info' : 'btn-outline-secondary'" (click)="typeFilter = 1">Multi Text</button>
          </div>
        </div>
        <button class="btn btn-sm btn-outline-primary" (click)="openAdd()">
          <i class="bi bi-plus-lg"></i> Add Template
        </button>
      </div>
      <div class="card-body p-0">
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border"></div>
        </div>
        <table *ngIf="!loading" class="table table-hover table-sm mb-0">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Type</th>
              <th>Category</th>
              <th>Site Type</th>
              <th class="text-center">Active</th>
              <th class="text-center">System</th>
              <th>Sort</th>
              <th>Preview</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="filteredTemplates.length === 0">
              <td colspan="10" class="text-center text-muted py-3">No templates found. Click "Add Template" to create one.</td>
            </tr>
            <tr *ngFor="let t of filteredTemplates">
              <td class="text-muted small align-middle">{{t.id}}</td>
              <td class="align-middle fw-semibold">{{t.name}}</td>
              <td class="align-middle">
                <span class="badge" [ngClass]="t.type === 0 ? 'bg-primary' : 'bg-info text-dark'">
                  {{ t.type === 0 ? 'Free Text' : 'Multi Text' }}
                </span>
              </td>
              <td class="align-middle">
                <span *ngIf="t.category" class="badge bg-secondary">{{t.category}}</span>
              </td>
              <td class="align-middle">
                <span *ngIf="t.siteType" class="badge bg-light text-dark border">{{t.siteType}}</span>
                <span *ngIf="!t.siteType" class="text-muted small">All</span>
              </td>
              <td class="text-center align-middle">
                <i [ngClass]="t.isActive ? 'bi bi-check-circle-fill text-success' : 'bi bi-x-circle text-muted'"></i>
              </td>
              <td class="text-center align-middle">
                <i [ngClass]="t.isSystem ? 'bi bi-shield-check text-primary' : 'bi bi-dash text-muted'"></i>
              </td>
              <td class="align-middle">{{t.sortOrder}}</td>
              <td class="align-middle">
                <img *ngIf="t.hasPreviewImage" [src]="getPreviewImageUrl(t.id)" style="height:40px; width: auto; border-radius:4px;" [alt]="t.name" />
                <span *ngIf="!t.hasPreviewImage" class="text-muted small">—</span>
              </td>
              <td class="align-middle text-end text-nowrap">
                <button class="btn btn-sm btn-outline-secondary me-1" title="Edit" (click)="openEdit(t)">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" title="Delete" (click)="delete(t)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
